import React, { useEffect, useRef, useState } from 'react';
import { renderPage } from './render';
import { bookProgress, pageStatus } from './progress';
import { ChevronLeft, DownloadIcon } from './icons';

const THUMB_WIDTH = 160;

// Lager små bilder av sidene slik eleven har fargelagt dem
const useColoredThumbnails = (pages, actions) => {
  const [thumbs, setThumbs] = useState({});
  useEffect(() => {
    let cancelled = false;
    (async () => {
      for (let i = 0; i < pages.length; i++) {
        const pageActions = actions[`page_${i}`] || [];
        if (pageActions.length === 0) continue;
        try {
          const full = await renderPage(pages[i].imageUrl, pageActions);
          const small = document.createElement('canvas');
          small.width = THUMB_WIDTH;
          small.height = Math.round(full.height * (THUMB_WIDTH / full.width));
          small.getContext('2d').drawImage(full, 0, 0, small.width, small.height);
          full.width = 0;
          if (cancelled) return;
          const url = small.toDataURL('image/jpeg', 0.85);
          setThumbs((prev) => ({ ...prev, [i]: url }));
        } catch (error) {
          console.error(error);
        }
        await new Promise((resolve) => setTimeout(resolve, 0));
      }
    })();
    return () => { cancelled = true; };
  }, [pages, actions]);
  return thumbs;
};

const Overview = ({ book, pages, currentPage, actions, answers, name, onSelect, onClose, onExport, isExporting }) => {
  const thumbs = useColoredThumbnails(pages, actions);
  const progress = bookProgress(book, answers);
  const dialogRef = useRef(null);

  useEffect(() => {
    dialogRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="overview" role="dialog" aria-modal="true" aria-labelledby="overview-title" tabIndex={-1} ref={dialogRef}>
      <header className="overview-header">
        <button className="outline-button" onClick={onClose}>
          <ChevronLeft size={20} /> Tilbake til {currentPage === 0 ? 'forsiden' : `side ${currentPage}`}
        </button>
        <h1 id="overview-title">Alle sider</h1>
        <div className="spacer" />
        <div className="overall-progress">
          <strong>{progress.text}</strong>
          <span className="progress-track" aria-hidden="true">
            <span style={{ width: `${progress.total ? (progress.done / progress.total) * 100 : 0}%` }} />
          </span>
        </div>
        <button className="primary-button" onClick={onExport} disabled={isExporting}>
          <DownloadIcon size={18} /> Lag PDF
        </button>
      </header>
      <div className="overview-grid">
        {pages.map((page, i) => {
          const status = pageStatus(book, i, answers, name);
          const title = i === 0 ? 'Forside' : (page.title || `Side ${i}`);
          return (
            <button key={i} className={`page-card${i === currentPage ? ' is-current' : ''}`} onClick={() => onSelect(i)}
              aria-current={i === currentPage ? 'page' : undefined}>
              <img src={thumbs[i] || page.imageUrl} alt="" />
              <span className="page-card-number">{i === 0 ? 'FORSIDE' : `SIDE ${i}`}</span>
              <span className="page-card-title">{title}</span>
              <span className={`page-card-status tone-${status.tone}`}>{status.text}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Overview;
